import { Navigate } from 'react-router-dom';

export default function CodingConsole() {
  return <Navigate to="/surgeon?tab=coding" replace />;
}
